import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export default function isReplyAllTheDefaultResponse() {
    var userConfiguration = getUserConfiguration();
    return userConfiguration.UserOptions
        ? userConfiguration.UserOptions.IsReplyAllTheDefaultResponse
        : true;
}
//# sourceMappingURL=isReplyAllTheDefaultResponse.js.map